import { useState } from 'react';
import { Outlet, Link, NavLink } from 'react-router-dom';
import logo from '@/assets/beantown_sign.svg';
import styles from './Layout.module.css';

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const year = new Date().getFullYear();

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo} alt="Beantown Pub" className={styles.logoImage} />
          </Link>

          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>

          <ul className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
            {(['/', '/about', '/contact', '/menu', '/drafts', '/parties'] as const).map((path) => (
              <li key={path}>
                <NavLink
                  to={path}
                  className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                  onClick={() => setMenuOpen(false)}
                  end={path === '/'}
                >
                  {path === '/' ? 'Home' : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                </NavLink>
              </li>
            ))}
            <li>
              <a href="https://www.facebook.com/BeantownPubMA/" className={styles.navLink} target="_blank" rel="noopener noreferrer">
                Facebook
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <h4 className={styles.footerEstablished}>Est. 1999</h4>
        <img src={logo} alt="Beantown Pub logo" className={styles.footerLogo} />
        <p className={styles.footerText}>100 Tremont St. Boston MA</p>
        <p className={styles.footerText}>Call: 617-426-0111</p>
        <p className={styles.footerText}>Stay Connected</p>
        <nav className={styles.footerSocial}>
          <a href="https://www.facebook.com/BeantownPubMA/" target="_blank" rel="noopener noreferrer">Facebook</a>
          {' '}
          <a href="https://www.instagram.com/explore/locations/392955632/beantown-pub/?hl=en" target="_blank" rel="noopener noreferrer">Instagram</a>
          {' '}
          <a href="https://twitter.com/BeantownPub" target="_blank" rel="noopener noreferrer">Twitter</a>
        </nav>
        <p className={styles.footerText}>&copy; {year} Beantown Pub</p>
      </footer>
    </div>
  );
}

export default Layout;
